import React, { useState, useEffect, useRef } from 'react';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import '../styles/main.css'; // Make sure to include your CSS file

interface ChatMessage {
  content: string;
  sender: string;
  type: string;
}

function App() {
  const [username, setUsername] = useState<string>('');
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [messageInput, setMessageInput] = useState<string>('');
  const [connecting, setConnecting] = useState<boolean>(true);

  const clientRef = useRef<Client | null>(null);

 useEffect(() => {
     const handleTabClose = (event: BeforeUnloadEvent) => {
       if (clientRef.current?.connected) {
               clientRef.current.publish({
                 destination: '/app/chat.sendMessage',
                 body: JSON.stringify({
                   content: '',
                   sender: username,
                   type: 'LEAVE',
                 }),
               });
             }
     };

     window.addEventListener('beforeunload', handleTabClose);

     return () => {
       window.removeEventListener('beforeunload', handleTabClose);
       if (clientRef.current?.connected) {
               clientRef.current.deactivate();
       }
     };
   }, [username]);

  const initializeWebSocket = () => {
    // Connect to WebSocket
    const socket = new SockJS('https://ws-api-service.fly.dev/ws');
    const stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    stompClient.onConnect = () => {
      console.log('Connected to WebSocket');
      setConnecting(false);

      stompClient.subscribe('/topic/public', (message: any) => {
        handleReceivedMessage(JSON.parse(message.body));
      });

      if (clientRef.current?.connected) {
        clientRef.current.publish({
          destination: '/app/chat.sendMessage',
          body: JSON.stringify({
            content: '',
            sender: username,
            type: 'JOIN',
          }),
        });
      }
    };

    stompClient.onStompError = (frame: any) => {
      console.error('Broker reported error: ' + frame.headers['message']);
      console.error('Additional details: ' + frame.body);
    };

    stompClient.activate();

    clientRef.current = stompClient;
  };


  useEffect(() => {
   // ComponentWillUnmount logic
      // This will be called when the component is unmounted
      return () => {
        if (clientRef.current?.connected) {
          clientRef.current.deactivate();
        }
      };
    }, []); // Empty dependency array means it runs once on mount and cleans up on unmount




  const handleReceivedMessage = (message: ChatMessage) => {
   console.log('---------------------------------------------------------------->' + message);
    setMessages((prevMessages) => [...prevMessages, message]);
  };

  const handleUsernameSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (username.trim() !== '') {
      setUsername(username.trim());
      initializeWebSocket();
      document.getElementById('username-page')?.classList.add('hidden');
      document.getElementById('chat-page')?.classList.remove('hidden');
    }

  };

  const handleMessageSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (messageInput.trim() !== '' && clientRef.current?.connected) {
      const message: ChatMessage = {
        content: messageInput.trim(),
        sender: username,
        type: 'CHAT',
      };
      clientRef.current.publish({
        destination: '/app/chat.sendMessage',
        body: JSON.stringify(message),
      });
      setMessageInput('');
    }
  };

  // Assume colors array is defined somewhere in your code
  const colors: string[] = [
    'red', 'green', 'blue', 'orange', 'brown', 'magenta',
    'darkgoldenrod', 'violet', 'deep-purple', 'deep-orange',
    'darkred', 'darkgreen', 'darkblue', 'darkorange', 'darkpurple', 'darkpink', 'darkteal', 'darkbrown', 'darkcyan', 'darkmagenta'
  ];

  const getAvatarColor = (messageSender: string): string => {
    if (typeof messageSender !== 'string' || messageSender.length === 0) {
      return 'darkgoldenrod';
    }

    let hash = 0;
    for (let i = 0; i < messageSender.length; i++) {
      hash = 31 * hash + messageSender.charCodeAt(i);
    }
    const index = Math.abs(hash % colors.length);
    return colors[index];
  };


  return (
    <div>
      <div id="username-page">
        <div className="username-page-container">
          <h1 className="title">Type your username to enter to the Centrepreneur channel</h1>
          <form id="usernameForm" name="usernameForm" onSubmit={handleUsernameSubmit}>
            <div className="form-group">
              <input
                type="text"
                id="name"
                placeholder="Username"
                autoComplete="off"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="form-group">
              <button type="submit" className="accent username-submit">
                Start Chatting
              </button>
            </div>
          </form>
        </div>
      </div>

      <div id="chat-page" className="hidden">
        <div className="chat-container">
          <div className="chat-header">
            <h2>Centrepreneur channel</h2>
          </div>
          <div className={`connecting ${connecting ? '' : 'hidden'}`}>Connecting...</div>
             <ul id="messageArea" style={{ height: '70vh', margin: '1vh 0', overflowY: 'auto' }}>
               {messages.map((msg, index) => (
                 <li key={index} className={msg.type === 'JOIN' || msg.type === 'LEAVE' ? 'event-message' : 'chat-message'}>
                   {msg.type === 'JOIN' || msg.type === 'LEAVE' ? (
                     <>{msg.sender} {msg.type === 'JOIN' ? 'joined!' : 'left!'}</>
                   ) : (
                     <>
                       <i style={{ backgroundColor: getAvatarColor(msg.sender) }}>{msg.sender[0]}</i>
                       <span>{msg.sender}</span>
                       <p>{msg.content}</p>
                     </>
                   )}
                 </li>
               ))}
             </ul>

          <form id="messageForm" name="messageForm" onSubmit={handleMessageSubmit}>
            <div className="form-group">
              <div className="input-group clearfix">
                <input
                  type="text"
                  id="message"
                  placeholder="Type a message..."
                  autoComplete="off"
                  className="form-control"
                  value={messageInput}
                  onChange={(e) => setMessageInput(e.target.value)}
                />
                <button type="submit" className="primary">
                  Send
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default App;
